module.exports = __webpack_public_path__ + "static/img/1.bd03fe74.png";